// removed by extract-text-webpack-plugin
module.exports = {"container":"hitDialog__container___zV6z3","info":"hitDialog__info___2hCMP","dartIcon":"hitDialog__dartIcon___3nxqv","targetBtn":"hitDialog__targetBtn___3N7EP","actions":"hitDialog__actions___1mFd1"};


//////////////////
// WEBPACK FOOTER
// ./containers/HitDialog/hitDialog.css
// module id = 277
// module chunks = 0